/**
 * Converts string, as space separated words, to lower case.
 *
 * @param {string} string
 *
 * @example
 * lowerCase('TESTSTRING');
 * //return 'teststring'
 * @example
 * lowerCase('Test_____String);
 * //return 'test string'
 * @example
 * lowerCase('Test-String');
 * return 'test string'
 *
 * @return {*}  {string}
 */
export var lowerCase = function (string) { return string
    .split(/-|_/g)
    .reduce(function (acc, value, index) { return "" + acc + (value && index ? ' ' : '') + value.toLowerCase(); }, ''); };
//# sourceMappingURL=lowerCase.js.map